import type { FC } from 'react'

import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'

import useTranslation from '@space-lib/hooks/useTranslation'
import Icon from '@space-shell/common/components/icon'
import clsx from 'clsx'

import { Box } from './memberListFiltersStyles'
import type { MemberListFiltersProps } from './types'

const MemberListFilters: FC<MemberListFiltersProps> = ({
  onClick,
  isActiveOrder = { memberType: false, name: false },
  disabled = false
}) => {
  const { t } = useTranslation()

  return (
    <Box className='_d-flex _align-items-center _px-5 _py-3 _border-bottom'>
      <button
        disabled={disabled}
        onClick={() => onClick('name')}
        className='_d-flex _align-items-center _border-0 btn'>
        <span className='_d-flex _mr-2'>
          {t('configuration_sidebar.members_and_permissions.list.title_section.name')}
        </span>
        <Icon className={clsx('rotate', { active: isActiveOrder.name })} icon={faChevronDown} />
      </button>
      <div className='_d-flex _align-items-center _justify-content-end _ml-auto _border-0 btn cursorDefault role'>
        <span className='_d-flex _px-4 _mr-2'>
          {t('configuration_sidebar.members_and_permissions.list.title_section.role')}
        </span>
      </div>
    </Box>
  )
}

export default MemberListFilters
